/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { AuthNumberDto } from '@gh/builder-shared-data';

export type AuthNumber = AuthNumberDto;

export function createDummyAuthRequest(): AuthNumber {
  return {};
}

export function createAuthRequest(entryPoint: string): AuthNumber {
  return { entryPoint };
}
